import { render, staticRenderFns } from "./GymSectorAvatar.vue?vue&type=template&id=cc53352a"
import script from "./GymSectorAvatar.vue?vue&type=script&lang=js"
export * from "./GymSectorAvatar.vue?vue&type=script&lang=js"
import style0 from "./GymSectorAvatar.vue?vue&type=style&index=0&id=cc53352a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports